interface NewsCard {
  category: string;
  title: string;
  paragraphs: string[];
}

const newsColumns: { cards: NewsCard[] }[] = [
  {
    cards: [
      {
        category: "HOW TO RIDE",
        title: "First time on Southern Transit? Here's what you need to know.",
        paragraphs: [
          "Learn everything you need to know before you ride. From finding your bus stop and tracking your bus to requesting a stop and understanding rider guidelines, this quick guide will help you ride with confidence.",
        ],
      },
      {
        category: "HOW TO RIDE",
        title: "How to make the most of your commute with Southern Transit.",
        paragraphs: [
          "Commuting doesn't have to be a hassle. With Southern Transit, you can enjoy a comfortable trip while making the most of your travel time. Explore simple tips to help you stay productive or unwind along the way.",
        ],
      },
    ],
  },
  {
    cards: [
      {
        category: "SERVICE NOTICE",
        title: "Construction Traffic Delays",
        paragraphs: [
          "Due to road work in the Trinidad area, our buses may run 10\u201330 minutes late during peak hours, including the morning and evening rushes.",
          "Please continue to arrive at your bus stop on time, as delay times may vary. You may also track your bus with our bus-tracking app.",
        ],
      },
      {
        category: "SERVICE NOTICE",
        title: "No Current Service Notices",
        paragraphs: [
          "Check back here for future updates that may affect your ride.",
          "The fastest way to receive service updates is to subscribe to Southern Transit emails using the form below to receive detours, schedule changes, and other important rider information directly in your inbox.",
        ],
      },
    ],
  },
  {
    cards: [
      {
        category: "NEWS",
        title: "Benefits of Public Transportation",
        paragraphs: [
          "Public transportation offers more than just a ride. Discover how it helps save money, reduces traffic, supports healthier communities, and benefits the environment \u2013 all while making it easier to get where you need to go.",
        ],
      },
      {
        category: "NEWS",
        title: "How Public Transit Strengthens Our Communities.",
        paragraphs: [
          "Learn how reliable transportation supports local businesses, expands opportunities, and helps create a stronger, more connected community for everyone.",
        ],
      },
    ],
  },
];

export default function NewsSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 md:mb-12">
          <div>
            <p className="text-xs font-label font-semibold tracking-[0.15em] text-primary-600 uppercase mb-3">
              Stay in the Loop
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-foreground-900 leading-tight">
              News, notices, &amp;{" "}
              <em className="text-primary-500 font-medium">rider guides</em>
            </h2>
          </div>
        </div>

        {/* Featured Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10 md:mb-14">
          <div className="rounded-xl overflow-hidden">
            <img
                          src="/images/h2.png"
              alt="Southern Transit bus at night with festive lights"
              className="w-full h-[240px] md:h-[280px] object-cover"
            />
          </div>
          <div className="rounded-xl overflow-hidden hidden md:block">
            <img
                          src="/images/h3.png"
              alt="Southern Transit bus on scenic road"
              className="w-full h-[240px] md:h-[280px] object-cover"
            />
          </div>
        </div>

        {/* News Cards Grid - 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {newsColumns.map((column, cIdx) => (
            <div key={cIdx} className="space-y-5">
              {column.cards.map((card, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 rounded-xl border border-background-200/70 p-6"
                >
                  {/* Category heading */}
                  <h3 className="font-heading text-sm font-bold tracking-wider uppercase text-foreground-800 mb-3">
                    {card.category}
                  </h3>

                  {/* Title */}
                  <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3 leading-snug">
                    {card.title}
                  </h4>

                  {/* Paragraphs */}
                  {card.paragraphs.map((paragraph, pIdx) => (
                    <p
                      key={pIdx}
                      className="text-sm text-foreground-600 leading-relaxed mb-3"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}